import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import {Alert} from 'react-bootstrap';

import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import SuppliersList from './SuppliersList';
import SupplierService from "./services/supplier.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

//const ExcelJS = require('exceljs');

class Suppliers extends Component {

  constructor(props) {
    super(props);
    this.onChangeSupplierFilterByDescr = this.onChangeSupplierFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);
    this.resetError = this.resetError.bind(this);

    this.state = {
      showerror: false,
      errmessage: "",
      listOfSuppliers: null,
      SupplierFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.SupplierFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.SupplierFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeSupplierFilterByDescr(e) {
    this.setState({
      SupplierFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.SupplierFilterByDescr, this.state.SortField,this.state.SortType).catch((e) => {
      this.setState({
        errmessage: e,
      });
      this.setState({
        showerror: true,
      });      
      console.log(this.state.errmessage);
    });;  
  }

  resetError() {
    this.setState({
      showerror: false,
      errmessage: "",
    });    
  }

  performSearch = async (descr,sortfield,sorttype) => {
    await SupplierService.getSupplierByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfSuppliers: response.data
        });
        console.log(this.state.listOfSuppliers);
      })
      .catch(e => {
        console.log(e);
        this.setState({
          errmessage: e,
        });
        this.setState({
          showerror: true,
        });         
        throw e.message;
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <Container>
        <Row className='mb-2 d-flex'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h1 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>SUPPLIERS</h1>
          <Col lg={true}>
            <FormLabel className='mb-2'>Filter By Supplier Description:</FormLabel>       
            <FormControl type="text" name="filterbySupplierdescription" id="filterbySupplierdescription" onChange={this.onChangeSupplierFilterByDescr}></FormControl>
          </Col>
          <Col lg={true}>
            <FormLabel className='mb-2'>Sort By:</FormLabel>       
              <FormControl as='select' onChange={this.onChangeSortField}>
                <option value="id">Supplier ID</option>
                <option value="suppliername">Supplier Name</option>
                <option value="suppliercontactperson">Supplier Contact</option>
              </FormControl>
          </Col>
          
          <Col sm={true}>
            <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
            <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
          </Col>          
        </Row>
        <Link to="/new-supplier" className="mr-2 btn btn-primary">New Supplier</Link>            
        <Button className="m-2 btn btn-primary">Export</Button>        
        <Row>
          <SuppliersList listOfSuppliers = {this.state.listOfSuppliers} />      
        </Row>

        <hr/>          
        {this.state.showerror && (
          <Alert variant="danger" onClose={this.resetError} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{this.state.errmessage}</p>
          </Alert>      
        )}

      </Container>
      </>
    )
  }
}

export default Suppliers;